export const SendActionsPostMessage = (message: string, event: string) => {
  setTimeout(() => {
    const iframe = document.getElementById('v1-container') as HTMLIFrameElement;

    if (iframe?.contentWindow) {
      iframe.contentWindow?.postMessage(
        {
          type: message,
          payload: {
            event: event,
            message,
          },
        },
        '*'
      );
    }
  }, 500);
};
